// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion, .accordion * {
  color: #fff !important;
}

.accordion {
  border-radius: 8px;
  margin: 14px 0 5px;
  font-size: 17px;
  font-weight: 400;
  position: relative;
  font-family: var(--brutal);
}
.accordion__item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px 0 0;
}
.accordion__item .flexed-c {
  display: flex;
}
.accordion__item__title {
  color: rgba(20, 37, 41, 0.7);
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  margin-right: 8px;
  white-space: nowrap;
}
.accordion__item__wrapper {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.accordion__item__wrapper .content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.accordion__item__wrapper .content .mx {
  margin: 0 4px;
}
.accordion__timer {
  align-items: center;
  color: var(--color-main-secondary-text) !important;
  display: flex;
  font-size: 12px;
  line-height: 13px;
  margin: 3px 0 8px -1px;
  white-space: nowrap;
  margin-left: auto;
}
.accordion__timer .timer {
  display: inline-block;
  color: currentColor !important;
  min-width: 11px;
  text-align: center;
  margin: 0 2px;
}
.accordion__timer .timer-svg {
  display: inline-block;
  margin: 0 4px 0 8px;
}
.accordion__timer .timer-loading-container {
  -webkit-box-align: center;
  -moz-box-align: center;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  transition: opacity 1s;
  vertical-align: middle;
  margin: 0 4px 0 8px;
  padding: 0;
  height: 11px;
}
.accordion__timer .timer-loading-container .timer-loading-svg {
  animation: rotate 2s linear infinite;
  position: relative;
  width: 11px;
  height: 11px;
  will-change: transform;
}
@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}
.accordion__timer .timer-loading-container .timer-loading-svg .circle {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 10;
  stroke-linecap: round;
  animation: loadAnimate 1.5s ease-in-out infinite;
}
@keyframes loadAnimate {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
.accordion .bolder {
  color: #142529;
}
.accordion .darker {
  color: #142529;
}
.accordion .arrow {
  filter: brightness(0) invert(1);
  display: inline-block;
  margin: 0 6px 0 10px;
}
.accordion .transformed {
  transform: rotate(-180deg);
  position: relative;
}
.accordion .info {
  vertical-align: middle;
  margin-left: 6px;
}
.accordion .custom-info-tooltip {
  background: var(--color-main-bg);
  border-radius: 16px;
  box-shadow: 0 0 36px var(--color-main-border);
  font-size: 14px;
  margin: 8px auto auto;
  padding: 20px 16px 18px;
  position: absolute;
  text-align: left;
  z-index: var(--z-index-tooltip);
  line-height: 17px;
  bottom: -4px;
  max-width: 315px;
  white-space: pre-wrap;
  width: calc(100vw - var(--space-content-x) * 2);
  left: -20px;
  width: calc(100vw - var(--space-content-x) * 2);
  max-height: 177px;
  min-width: 288px;
}
.accordion .custom-info-tooltip p:not(:first-child) {
  margin-top: 10px;
}
.accordion .custom-info-tooltip.hidden {
  opacity: 0;
  pointer-events: none;
}
.accordion__expanded {
  height: 0;
  overflow: hidden;
  font-size: 14px;
  margin-bottom: 4px;
  line-height: 17px;
  transition: height 0.2s, opacity 0.1s 0.1s;
  will-change: height, opacity;
}
.accordion__expanded.expanded {
  margin-bottom: 11px;
  height: 96px;
}
.accordion__expanded.expanded li {
  opacity: 1;
}
.accordion__expanded li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  transition: opacity 0.2s ease-out 0.05s;
  padding: 7px 0 8px;
}
.accordion__expanded li * {
  font-size: 14px;
  line-height: 17px;
  font-family: var(--brutal);
}
.accordion__expanded li:last-child {
  margin-bottom: 0;
}
.accordion__expanded li .fee-container {
  display: flex;
  align-items: center;
  align-items: center;
  position: relative;
}
.accordion__expanded li .fee-container .tooltip-container {
  margin-left: 20px;
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/MercuryoWidget/Styles/Accordion.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;AACF;;AACA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAEF;AAAE;EAEE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AACJ;AACI;EACE,aAAA;AACN;AAEI;EACE,4BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAAN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAAN;AAEM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAAR;AACQ;EACE,aAAA;AACV;AAKE;EAIE,mBAAA;EACA,kDAAA;EAIA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;AAII;EACE,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;AAFN;AAII;EACE,qBAAA;EACA,mBAAA;AAFN;AAKI;EACE,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,mBAAA;EAGA,oBAAA;EAEA,uBAAA;EAIA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AAHN;AAKM;EAGE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAHR;AAoBQ;EACE;IAIE,wBAAA;EANV;AACF;AASQ;EACE,wBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,gDAAA;AAPV;AA4CQ;EACE;IACE,wBAAA;IACA,oBAAA;EAdV;EAiBQ;IACE,yBAAA;IACA,sBAAA;EAfV;EAkBQ;IACE,yBAAA;IACA,uBAAA;EAhBV;AACF;AA2BE;EACE,cAAA;AAzBJ;AA2BE;EACE,cAAA;AAzBJ;AA2BE;EAEE,+BAAA;EACA,qBAAA;EACA,oBAAA;AA1BJ;AA4BE;EACE,0BAAA;EACA,kBAAA;AA1BJ;AA6BE;EACE,sBAAA;EACA,gBAAA;AA3BJ;AA6BE;EACE,gCAAA;EACA,mBAAA;EAEA,6CAAA;EACA,eAAA;EACA,qBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EAGA,YAAA;EACA,gBAAA;EACA,qBAAA;EAGA,+CAAA;EACA,WAAA;EAGA,+CAAA;EACA,iBAAA;EACA,gBAAA;AA9BJ;AAgCI;EACE,gBAAA;AA9BN;AAiCI;EACE,UAAA;EACA,oBAAA;AA/BN;AAmCE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EAEA,kBAAA;EACA,iBAAA;EAIA,0CAAA;EACA,4BAAA;AAlCJ;AAmCI;EACE,mBAAA;EACA,YAAA;AAjCN;AAkCM;EACE,UAAA;AAhCR;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;AAjCN;AAkCM;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;AAhCR;AAsCM;EACE,gBAAA;AApCR;AAuCM;EACE,aAAA;EACA,mBAAA;EAIA,mBAAA;EACA,kBAAA;AArCR;AAuCQ;EACE,iBAAA;EACA,eAAA;AArCV","sourcesContent":["@import \"../../../../assets/styles/variables\";\n\n.accordion, .accordion *{\n  color: #fff!important;\n}\n.accordion{\n  border-radius: 8px;\n  margin: 14px 0 5px;\n  font-size: 17px;\n  font-weight: 400;\n  position: relative;\n  font-family: var(--brutal);\n\n  &__item{\n    //padding: 8px 16px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 15px 0 0;\n    //flex-wrap: wrap;\n    .flexed-c{\n      display: flex;\n      //flex-direction: column;\n    }\n    &__title{\n      color: rgba(20, 37, 41, 0.70);\n      display: block;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 22px;\n      margin-right: 8px;\n      white-space: nowrap;\n    }\n    &__wrapper{\n      display: flex;\n      align-items: center;\n      margin-left: auto;\n      //flex-direction: column;\n      .content{\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        justify-content: flex-end;\n        .mx{\n          margin: 0 4px;\n        }\n      }\n    }\n  }\n\n  &__timer{\n    -webkit-box-align: center;\n    -moz-box-align: center;\n    -webkit-align-items: center;\n    align-items: center;\n    color: var(--color-main-secondary-text)!important;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-box;\n    display: flex;\n    font-size: 12px;\n    line-height: 13px;\n    margin:3px 0 8px -1px;\n    white-space: nowrap;\n    margin-left: auto;\n    .timer{\n      display: inline-block;\n      color: currentColor!important;\n      min-width: 11px;\n      text-align: center;\n      margin: 0 2px;\n    }\n    .timer-svg{\n      display: inline-block;\n      margin: 0 4px 0 8px;\n    }\n\n    .timer-loading-container {\n      -webkit-box-align: center;\n      -moz-box-align: center;\n      -webkit-box-pack: center;\n      -moz-box-pack: center;\n      -webkit-align-items: center;\n      align-items: center;\n      display: -webkit-inline-flex;\n      display: -moz-inline-box;\n      display: inline-flex;\n      -webkit-justify-content: center;\n      justify-content: center;\n      -webkit-transition: opacity 1s;\n      -o-transition: opacity 1s;\n      -moz-transition: opacity 1s;\n      transition: opacity 1s;\n      vertical-align: middle;\n      margin: 0 4px 0 8px;\n      padding: 0;\n      height: 11px;\n\n      .timer-loading-svg {\n        -webkit-animation: rotate 2s linear infinite;\n        -moz-animation: rotate 2s linear infinite;\n        animation: rotate 2s linear infinite;\n        position: relative;\n        width: 11px;\n        height: 11px;\n        will-change: transform;\n\n\n        @-webkit-keyframes rotate {\n          to {\n            -webkit-transform: rotate(1turn);\n            transform: rotate(1turn)\n          }\n        }\n\n        @-moz-keyframes rotate {\n          to {\n            -moz-transform: rotate(1turn);\n            transform: rotate(1turn)\n          }\n        }\n\n        @keyframes rotate {\n          to {\n            -webkit-transform: rotate(1turn);\n            -moz-transform: rotate(1turn);\n            -o-transform: rotate(1turn);\n            transform: rotate(1turn)\n          }\n        }\n\n        .circle {\n          stroke-dasharray: 1,200;\n          stroke-dashoffset: 10;\n          stroke-linecap: round;\n          -webkit-animation: loadAnimate 1.5s ease-in-out infinite;\n          -moz-animation: loadAnimate 1.5s ease-in-out infinite;\n          animation: loadAnimate 1.5s ease-in-out infinite;\n        }\n\n        @-webkit-keyframes loadAnimate {\n          0% {\n            stroke-dasharray: 1,200;\n            stroke-dashoffset: 0\n          }\n\n          50% {\n            stroke-dasharray: 89,200;\n            stroke-dashoffset: -35\n          }\n\n          to {\n            stroke-dasharray: 89,200;\n            stroke-dashoffset: -124\n          }\n        }\n\n        @-moz-keyframes loadAnimate {\n          0% {\n            stroke-dasharray: 1,200;\n            stroke-dashoffset: 0\n          }\n\n          50% {\n            stroke-dasharray: 89,200;\n            stroke-dashoffset: -35\n          }\n\n          to {\n            stroke-dasharray: 89,200;\n            stroke-dashoffset: -124\n          }\n        }\n\n        @keyframes loadAnimate {\n          0% {\n            stroke-dasharray: 1,200;\n            stroke-dashoffset: 0\n          }\n\n          50% {\n            stroke-dasharray: 89,200;\n            stroke-dashoffset: -35\n          }\n\n          to {\n            stroke-dasharray: 89,200;\n            stroke-dashoffset: -124\n          }\n        }\n      }\n    }\n  }\n  .amount{\n    //color: rgba(20, 37, 41, 0.50);\n  }\n  .amount-for{\n    //color: rgba(20, 37, 41, 0.50);\n  }\n  .bolder{\n    color: #142529;\n  }\n  .darker{\n    color: #142529;\n  }\n  .arrow{\n    //transition: transform .3s ease-out;\n    filter: brightness(0) invert(1);\n    display: inline-block;\n    margin: 0 6px 0 10px;\n  }\n  .transformed{\n    transform: rotate(-180deg);\n    position: relative;\n    //left: 16px;\n  }\n  .info{\n    vertical-align: middle;\n    margin-left: 6px;\n  }\n  .custom-info-tooltip{\n    background: var(--color-main-bg);\n    border-radius: 16px;\n    -webkit-box-shadow: 0 0 36px var(--color-main-border);\n    box-shadow: 0 0 36px var(--color-main-border);\n    font-size: 14px;\n    margin: 8px auto auto;\n    //max-width: 100%;\n    padding: 20px 16px 18px;\n    position: absolute;\n    text-align: left;\n    z-index: var(--z-index-tooltip);\n    line-height: 17px;\n    //bottom: 0;\n    //right: auto;\n    bottom: -4px;\n    max-width: 315px;\n    white-space: pre-wrap;\n    width: -webkit-calc(100vw - var(--space-content-x)*2);\n    width: -moz-calc(100vw - var(--space-content-x)*2);\n    width: calc(100vw - var(--space-content-x)*2);\n    left: -20px;\n    width: -webkit-calc(100vw - var(--space-content-x)*2);\n    width: -moz-calc(100vw - var(--space-content-x)*2);\n    width: calc(100vw - var(--space-content-x)*2);\n    max-height: 177px;\n    min-width: 288px;\n\n    p:not(:first-child) {\n      margin-top: 10px;\n    }\n\n    &.hidden {\n      opacity: 0;\n      pointer-events: none;\n    }\n  }\n\n  &__expanded{\n    height: 0;\n    overflow: hidden;\n    font-size: 14px;\n    //height: 93px;\n    margin-bottom: 4px;\n    line-height: 17px;\n    -webkit-transition: height .2s,opacity .1s .1s;\n    -o-transition: height .2s,opacity .1s .1s;\n    -moz-transition: height .2s,opacity .1s .1s;\n    transition: height .2s,opacity .1s .1s;\n    will-change: height,opacity;\n    &.expanded{\n      margin-bottom: 11px;\n      height: 96px;\n      li{\n        opacity: 1;\n      }\n    }\n    li{\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      opacity: 0;\n      transition: opacity .2s ease-out .05s;\n      padding: 7px 0 8px;\n      * {\n        font-size: 14px;\n        line-height: 17px;\n        font-family: var(--brutal);\n      }\n      &:first-child{\n        //border-top: 1px solid rgba(25, 46, 51, 0.40);\n        //padding-top: 8px;\n      }\n      &:last-child{\n        margin-bottom: 0;\n      }\n\n      .fee-container {\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -moz-box-align: center;\n        -webkit-align-items: center;\n        align-items: center;\n        position: relative;\n\n        .tooltip-container {\n          margin-left: 20px;\n          position: fixed;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
